import CIcon from "@coreui/icons-react";
import { CFormInput, CInputGroup, CInputGroupText } from "@coreui/react";
import { t } from "i18next";

const Input = ({name, label, icon, iconStart = true, className, formData, placeholder, required,  formErrors = {}, validateForm, handleChange, type}) => {

  return (
    <>
        <div className={'mb-3 ' + className}>
            <div className="d-flex flex-column text-start">
                <label htmlFor={name} className="form-label">{ t(label)} <span className="text-danger">{required ? '*' : ''}</span></label>
                <CInputGroup>
                    {icon && iconStart &&
                        <CInputGroupText className="hst-left-radius">
                            <CIcon icon={icon} />
                        </CInputGroupText>
                    }
                    <CFormInput
                        id={name}
                        name={name}
                        className={icon && iconStart && 'hst-input-link-cardlink'}
                        placeholder={t(placeholder)}
                        type={type || "text"}
                        autoComplete={name}
                        value={formData[name]}
                        onChange={(e) => {
                            handleChange(e);
                            validateForm(e);
                        }}
                        onBlur={validateForm}
                    />
                    {icon && !iconStart &&
                        <CInputGroupText>
                            <CIcon icon={icon} />
                        </CInputGroupText>
                    }
                </CInputGroup>
            </div>
            {
                (formErrors[name] && (
                    <div role="alert" className='pt-1 d-flex align-items-center smart-field-error'>
                        <div className='text-danger text-start'>{t('error.error') + ': ' + formErrors[name]}</div>
                    </div>
                )) || <div className="smart-field-error-hidden"></div>
            }
        </div>
    </> 
  );
}

export default Input;